import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { MessageService } from "./message.service";
import { tap } from 'rxjs/operators';
import { Store } from "@ngrx/store";
import { AppState } from "../core/reducers";
import { Logout, LogoutLeilao } from "../core/actions/auth.action";

@Injectable({
  providedIn: 'root'
})
export class InterceptService {

  private returnUrl: string = "";

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private message: MessageService,
    private redirect: Router,
    private modalCtrl: NgbModal
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.returnUrl = event.url;
      }
    });
  }

  // intercept request and add token
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // tslint:disable-next-line:no-debugger
    // modify request
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem(environment.authTokenKey)}`
      }
    });
    // console.log('----request----');
    // console.log(request);
    // console.log('--- end of request---');

    return next.handle(request).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            // console.log('event intercept', event);
            if (event.status == 201) {
              this.message.toastSuccess(event.body.message, '');
            }
          }
        },
        error => {
          if (request.url.includes('/leilao/login')) {
            if (error.status == 0) {
              this.message.alertNet();
            }
            else{
              let message = error.error.message;
              this.message.toastError(message, 'Revise as informações');
            }

            throw error;
          }

          if (error.status == 0) {
            this.message.alertNet();
            return;
          }

          let message = "";
          if (Array.isArray(error.error?.erros)) {
            for (let err of error.error.erros) {
              message += `${err} \n`;
            }
          } else if (error.error?.message) {
            message = error.error.message;
          }

          if (error.status == 401) {

            this.modalCtrl.dismissAll();
            const token = localStorage.getItem(environment.authTokenKey);

            if (this.isLeilaoToken(token) || request.url.includes('/app-leilao')) {
              this.message.toastError(
                  'Estamos realizando uma pausa programada nas contratações. Nosso atendimento será retomado em breve. Agradecemos pela compreensão.',
                  'Voltamos em breve!'
              );
              this.store.dispatch(new LogoutLeilao());
            } else {
              this.message.toastError('Faça login novamente para continuar', 'Sessão expirada');
              this.store.dispatch(new Logout());
            }
            return;
          }

          if (error.status == 403) {
            this.message.toastError(
              message || 'Você não possui permissão para esta ação.',
              'Acesso negado'
            );
            return;
          }

          if (error.status >= 500) {
            this.message.toastError(
              message || 'Erro interno do servidor. Tente novamente em instantes.',
              'Falha no servidor'
            );
            return;
          }

          this.message.toastError(message || 'Falha na requisição', 'Falha na requisição');
        }
      )
    );
  }

  private isLeilaoToken(token: string | null): boolean {
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.codigo && payload.cpf;
    } catch (e) {
      return false;
    }
  }

}
